import React, {useState} from 'react'
import {Box, Tab} from '@mui/material'
import {TabContext, TabList, TabPanel} from '@mui/lab'
import withLayout from '../../hocs/Layout'
import PageTitle from '../../common/PageTitle'
import B2cNotification from './B2cNotification'
import RvpNotification from './RvpNotification'
import B2bNotification from './B2bNotification'
import {decodeChannelAccess} from '../../helpers/UtilityHelper'
import {isAdmin} from '../../helpers/ReduxHelpers'
import {pageContainerSx, tabContainerSx, tabBarSx, tabPanelSx} from '../../styles/patterns'

const Notification = () => {
  const channelAccess = decodeChannelAccess()

  const showB2c = channelAccess.B2C_ACCESS || isAdmin()
  const showB2b = channelAccess.PTL_ACCESS || isAdmin()

  const [currentTab, setCurrentTab] = useState(showB2c ? 'B2c' : 'B2b')

  const handleTabChange = (_event, newValue) => {
    setCurrentTab(newValue)
  }

  return (
    <Box sx={pageContainerSx}>
      <PageTitle subTitle="Configure B2C forward, B2C RVP and B2B notification preferences">Manage Notifications</PageTitle>

      <TabContext value={currentTab}>
        <Box sx={tabContainerSx}>
          <TabList
            onChange={handleTabChange}
            variant="scrollable"
            scrollButtons="auto"
            sx={tabBarSx}
          >
            {showB2c && <Tab label="B2C Forward" value="B2c" />}
            {/* RVP is a B2C-only feature, so it follows the B2C access flag. */}
            {showB2c && <Tab label="B2C RVP" value="Rvp" />}
            {showB2b && <Tab label="B2B" value="B2b" />}
          </TabList>

          {showB2c && (
            <TabPanel value="B2c" sx={tabPanelSx}>
              <B2cNotification />
            </TabPanel>
          )}
          {showB2c && (
            <TabPanel value="Rvp" sx={tabPanelSx}>
              <RvpNotification />
            </TabPanel>
          )}
          {showB2b && (
            <TabPanel value="B2b" sx={tabPanelSx}>
              <B2bNotification />
            </TabPanel>
          )}
        </Box>
      </TabContext>
    </Box>
  )
}

export default withLayout(Notification)
